module.exports = __webpack_public_path__ + "img/06_cg.d515f38a.png";